import React from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles(() => ({
    root: {
        backgroundColor: 'transparent',
        boxShadow: 'none',

        '& .MuiExpansionPanelSummary-root': {
            backgroundColor: 'transparent',
            maxHeight: 0,
            minHeight: 0,
            padding: 0,
            marginTop: -6,
        },

        '& .MuiExpansionPanelDetails-root': {
            flexDirection: 'column',
            marginLeft: -3,
            padding: 0,
        },
    },
}));

interface Props {
    open: boolean;
    children: React.ReactNode;
};

const ExpandableSection = ({open, children}: Props) => {
    const classes = useStyles();

    return (
        <ExpansionPanel expanded={open} className={classes.root}>
            <ExpansionPanelSummary/>
            <ExpansionPanelDetails>
                {children}
            </ExpansionPanelDetails>
        </ExpansionPanel>
    );
};

export default ExpandableSection;
